#sales-rep{height:calc(100% - 5rem);overflow:hidden;position:relative}#sales-rep-content{height:-webkit-calc(100% - 9rem);height:calc(100% - 9rem);overflow:hidden}
/*# sourceMappingURL=sales-rep.component-Z7FWO4WT.css.map */
